import axios from "axios";
import { baseUrlApi } from "constants/defaultValues";

export const clientApplication = axios.create({
  baseURL: baseUrlApi,
  headers: {
    "Content-Type": "application/json",
  },
});

export const clientFormData = axios.create({
  baseURL: baseUrlApi,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const clientResponseType = axios.create({
  baseURL: baseUrlApi,
  headers: {
    responseType: "blob",
  },
});
